var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9167 7.4169C21.2751 7.65857 22.6001 11.9419 18.5834 17.0002C16.4029 19.6384 13.3202 21.3728 9.93339 21.8669C7.64172 22.1836 4.28339 22.4586 0.891724 19.9002C3.36611 20.0459 5.81004 19.2944 7.77506 17.7836C7.77506 17.7836 4.24172 17.5002 3.40839 14.5586C3.40839 14.5586 5.07506 14.5586 5.37506 14.5086C5.37506 14.5086 1.59172 13.2336 1.64172 9.61691C2.26572 9.90495 2.93877 10.0718 3.62506 10.1086C2.70586 9.37245 2.07283 8.33823 1.83545 7.18478C1.59806 6.03133 1.77125 4.83118 2.32506 3.79191C3.49848 5.27539 4.98226 6.48419 6.67231 7.33354C8.36236 8.18288 10.2178 8.6522 12.1084 8.70857C12.1084 8.70857 11.5667 4.54191 15.2084 3.25857C15.2084 3.25857 18.3001 1.97524 20.3667 4.38357C20.3667 4.38357 22.7751 3.99191 23.3167 3.25857C23.2168 3.79313 23.0028 4.29986 22.6893 4.74422C22.3758 5.18859 21.9701 5.56014 21.5001 5.83357C22.3989 5.82309 23.2852 5.6214 24.1001 5.24191C23.4691 6.05804 22.7353 6.78911 21.9167 7.4169Z",
    fill: "#2B2F68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.26dea3de.svg";
export { ForwardRef as ReactComponent };